/// <amd-module name="Wit/DeliveryPlans/Common/ErrorHandling" />

import { GlobalMessageLevel, IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { traceError, traceException } from "VSS/Platform/Trace";
import * as Resources from "Wit/DeliveryPlans/Resources";
import { TelemetryConstants } from "./Utils/TelemetryUtils";

export function reportError(pageContext: IVssPageContext, feature: string, ex: Error | string): void {
    const globalMessageService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");

    traceException(pageContext, TelemetryConstants.Area, feature, ex);

    const status = (ex as any).status || 0;
    const message = format(Resources.OperationFailed, `${ex instanceof Error ? ex.message : ex}${status ? " (" + status + ")" : ""}`);

    globalMessageService.addBanner({
        message,
        dismissable: true,
        level: GlobalMessageLevel.error
    });
}

export function reportWarning(pageContext: IVssPageContext, message: string): void {
    const globalMessageService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
    globalMessageService.addBanner({
        message,
        dismissable: true,
        level: GlobalMessageLevel.warning
    });
}

export function reportDataProviderError(pageContext: IVssPageContext, feature: string, contributionId: string): void {
    const globalMessageService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    const dataProviderException = contributionService.getDataProviderExceptions()[contributionId];
    traceError(pageContext, TelemetryConstants.Area, feature, "Failed to load data provider data.", {
        contributionId,
        stack: getStack(),
        dataProviderException
    });

    const message = dataProviderException
        ? format(Resources.DataProviderFailureErrorMessage, dataProviderException.message)
        : Resources.DataProviderFailure;
    globalMessageService.addBanner({ message, dismissable: true, level: GlobalMessageLevel.error });
}

function getStack() {
    try {
        throw Error();
    } catch (err) {
        return (err as Error).stack;
    }
}
